import React, { useEffect, useState } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import Sidebar from '../common/sidebar';
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import Select from 'react-select';

const AddChefs = () => {
  const [groupName, setGroupName] = useState('');
  const [priceBand, setPriceBand] = useState([]);
  const [priceBands, setPriceBands] = useState([]);
  const [errorMsg, setErrorMsg] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState([]);
  const [primaryAccount, setPrimaryAccount] = useState(null);
  const [status, setStatus] = useState('active');  
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [existingChefs, setExistingChefs] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [restrictedAccounts, setRestrictedAccounts] = useState([]);
  const [restrictedLoaded, setRestrictedLoaded] = useState(false);
  const [hoAccountlist, setHoAccountcodelist] = useState([]);
  const [hoAccountLoaded, setHoAccountLoaded] = useState(false);
  const [chefAccountList, setChefAccountList] = useState([]);
  const [chefAccountLoaded, setChefAccountLoaded] = useState(false);
  // Redirect unauthenticated or unauthorized users
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = '/';
  }
  if (JSON.parse(sessionStorage.getItem('authData')) !== '' &&
    !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_chefs')) {
    window.location.href = '/unauthorized';
  }
  useEffect(() => {
    http.get(BaseUrl + 'admin/accountcodelist') // get restricted accounts
      .then((res) => {
        const ids = res.data?.data?.map(acc => acc.accountCode);
          setRestrictedAccounts(ids || []);
          console.log("Restricted Accounts:", ids);
        })
      .catch((err) => {
        console.error("Failed to fetch restricted accounts", err);
        setRestrictedAccounts([]);
      })
      .finally(() => {
        setRestrictedLoaded(true);
      });
  }, []);
  // get ho accounts
  useEffect(() => {
    http.get(BaseUrl + "admin/hoaccountlist")
      .then((res) => {
        const Hoids = res.data?.data?.map(acc => acc.accountCode);
        setHoAccountcodelist(Hoids || []);
        console.log("Ho Accounts:", Hoids);
      })
      .catch((err) => {
        console.error("Failed to fetch Ho accounts", err);
        setHoAccountcodelist([]);
      })
      .finally(() => {
        setHoAccountLoaded(true);
      });
  }, []);
  useEffect(() => {
    http.get(BaseUrl + "admin/chefaccountcodelist")
      .then((res) => {
        const chefIds = res.data?.data?.map(acc => acc.accountCode);
        setChefAccountList(chefIds || []);
        console.log("Chef Restricted Accounts:", chefIds);
      })
      .catch((err) => {
        console.error("Failed to fetch Chef restricted accounts", err);
        setChefAccountList([]);
      })
      .finally(() => {
        setChefAccountLoaded(true);
      });
  }, []);
  // Helper to get all already used accounts primary + sub for selected price bands
  const getUsedAccountIds = () => {
    const selectedBands = priceBand.map(pb => pb.value);
    return existingChefs
      .filter(chef =>
        chef.priceBand?.some(band => selectedBands.includes(band))
      )
      .flatMap(chef => [
        ...(chef.accounts || []).map(acc => acc._id || acc),
        chef.primaryAccount?._id || chef.primaryAccount
      ])
      .filter(Boolean); 
  };

 // Fetch unique price bands
  useEffect(() => {
    if (!restrictedLoaded || !hoAccountLoaded || !chefAccountLoaded) return;
    const fetchPriceBands = async () => {
      try {
        const response = await http.get(`${BaseUrl}admin/account`);
        const accountsData = response.data.data;
        let activeAccounts = accountsData.filter(acc => {
          return (
            acc.accountStatus === "active" &&
            acc.accountWebSiteAccess === "Yes"
          );
        });
        setAccounts(activeAccounts);
        const uniqueBands = [
          ...new Set(activeAccounts.map(acc => acc.accountPriceListId).filter(Boolean))
        ];
        setPriceBands(uniqueBands);
      } catch (error) {
        console.error('Error fetching price bands:', error);
      }
    };

    const fetchChefs = async () => {
      try {
        const response = await http.get(`${BaseUrl}admin/getchefs`);
        setExistingChefs(response.data.data || []);
      } catch (error) {
        console.error("Error fetching existing chefs", error);
      }
    };

    fetchPriceBands();
    fetchChefs();
  }, [restrictedLoaded, hoAccountLoaded, chefAccountLoaded]); 

  // if price band or account name change
  useEffect(() => {
    if (priceBand.length > 0) {
      const selectedBands = priceBand.map(pb => pb.value);
      const filtered = accounts.filter(acc => selectedBands.includes(acc.accountPriceListId));
      setFilteredAccounts(filtered);
      setSelectedAccount([]); // Reset selection on price change
      setPrimaryAccount(null); // Reset primary account selection on price change
      setFormSubmitted(false);
    } else {
      setFilteredAccounts([]);
      setSelectedAccount([]);
      setPrimaryAccount(null);
    }
  }, [priceBand, accounts]);

  const cancelbtn = (e) => {
    e.preventDefault();
    window.location.href = '/development-chef';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    let errors = {};
  
    if (!groupName.trim()) {
      errors.groupName = 'This field is required';
    }
    const duplicate = existingChefs.find(chef => chef.groupName.toLowerCase() === groupName.trim().toLowerCase());
    if (duplicate) {
      errors.groupName = 'Group name already exists';
    }
    if (!priceBand || priceBand.length === 0) {
      errors.priceBand = 'This field is required';
    }
    if (!primaryAccount) {
      errors.primaryAccount = 'This field is required';
    }
    setErrorMsg(errors);
  
    if (Object.keys(errors).length === 0) {
      // Prepare data to send
      const payload = {
        groupName,
        priceBand: priceBand.map(pb => pb.value),
        primaryAccount: primaryAccount._id, 
        accounts: selectedAccount.map(acc => acc.value), 
        groupStatus: status
      };
      
      try {
        const response = await http.post(`${BaseUrl}admin/addchef`, payload);
        setIsLoading(false);
        setAlertMessage('Development Chef Added Successfully');
        setAlertPopup(true);
      } catch (error) {
        setIsLoading(false);
        const msg = error?.response?.data?.message || "Error Adding Development Chef";
        setAlertMessage(msg);
        setAlertPopup(true);
        console.error("Error:", error);
      }
    }
  };

  return (
    <section className="dashboard-block">
      {alertPopup && (
      <div className='custom-alert-pop common_alert_popup' style={{ display: "block" }}>
        <div className='custom-alert-container'>
          <div className='custom-alert-wrap'>
            <div className='custom-alert-header'>
              <h4>Alert</h4>
            </div>
            <div className='custom-alert-body'>
              <p>{alertMessage}</p>

              <div className='alert-buttons'>
                <a onClick={() => window.location.href = '/development-chef'} className="popup-alert-btn button">OK</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <h1 className="checkout-title">Add Development Chef</h1>
            <div className="right-table-outer-wrap">
              <form 
                method="post" 
                className="addform form-container-xs"
                onSubmit={handleSubmit}
              >
                <div className="input-field col-1">
                  <label>Group Name</label>
                  <input 
                    type="text" 
                    value={groupName} 
                    onChange={(e) => {
                      setGroupName(e.target.value);
                      setErrorMsg(prev => ({ ...prev, groupName: '' }));
                    }}                    
                    className="form-control" 
                    placeholder="Enter Group Name" 
                  />
                  {formSubmitted && errorMsg.groupName && <div className="error-msg">{errorMsg.groupName}</div>}
                </div>

                <div className="input-field col-1">
                <label>Price Band</label>
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  value={priceBand}
                  onChange={(selected) => {
                
                      setPriceBand(selected);
                      setErrorMsg(prev => ({ ...prev, priceBand: '' }));
                    
                  }}
                  options={priceBands.map(band => ({ value: band, label: band }))}
                  className="form-control"
                  placeholder="Select Price Bands"
                  styles={{
                    menu: (base) => ({
                      ...base,
                      position: 'relative',
                      zIndex: 1
                    })
                  }}
                />
                  {formSubmitted && errorMsg.priceBand && <div className="error-msg">{errorMsg.priceBand}</div>}
                </div>
                
                {priceBand.length > 0 && (
                  <div className="input-field col-1">
                    <label>Select Primary Account</label>
                    <select 
                      value={primaryAccount?._id || ""}
                      onChange={(e) => {
                        const selected = filteredAccounts.find(a => a._id === e.target.value);
                        if (selected) {
                          setPrimaryAccount(selected);
                          setErrorMsg(prev => ({ ...prev, primaryAccount: '' }));
                          setFormSubmitted(false);
                          // Remove the new primary account from selectedAccount list (if already selected)
                          setSelectedAccount(prev =>
                            prev.filter(acc => acc.value !== selected._id)
                          );
                        } else {
                          setPrimaryAccount(null);
                          setSelectedAccount([]);
                        }
                      }}
                      className="form-control"
                    >
                     <option value="">-- Select Primary Account --</option>
                      {filteredAccounts
                      .filter(account => (!getUsedAccountIds().includes(account._id) || account._id === primaryAccount?._id) && account.accountWebSiteAccess === "Yes" && !hoAccountlist.includes(account.accountCode) && !chefAccountList.includes(account.accountCode) )
                        .map(account => (
                          <option key={account._id} value={account._id}>
                            {account.accountCode} - {account.accountName}
                          </option>
                      ))}
                    </select>
                    {formSubmitted && errorMsg.primaryAccount && <div className="error-msg">{errorMsg.primaryAccount}</div>}
                  </div>
                )}

                {primaryAccount && (
                  <div className="input-field col-1">
                    <label>Select Sub-Account Name (s)</label>
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      options={filteredAccounts
                        .filter(acc => acc._id !== primaryAccount._id && !chefAccountList.includes(acc.accountCode) &&
                        (!getUsedAccountIds().includes(acc._id) || selectedAccount.some(sa => sa.value === acc._id))
                      )
                      .map(acc => ({
                        value: acc._id,
                        label: `${acc.accountCode} - ${acc.accountName}`,
                        data: acc
                      }))
                    }

                      value={selectedAccount}
                      onChange={(selected) => {
                        setSelectedAccount(selected);
                        setErrorMsg(prev => ({ ...prev, selectedAccount: '' }));
                      }}
                      className="form-control"
                      styles={{
                        menu: (base) => ({
                          ...base,
                          position: 'relative', 
                          zIndex: 1
                        })
                      }}
                    />
                    {formSubmitted && errorMsg.selectedAccount && <div className="error-msg">{errorMsg.selectedAccount}</div>}
                  </div>
                )}

                {/* Status Checkbox */}
              <div className="input-field col-1">
                <label className='full-width'>Status</label>
                <select className='col-4' value={status} onChange={(e) => setStatus(e.target.value)}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

                <button type="submit">Submit</button>&nbsp;&nbsp;
                <button onClick={cancelbtn}>Cancel</button>
              </form>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};

export default AddChefs;
